const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  search: "",
  transectionType: "",
  pageNo: 1,
};

const filterSlice = createSlice({
  name: "transactionFilter",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setTransectionType: (state, action) => {
      state.transectionType = action.payload;
    },
    setPageNo: (state, action) => {
      state.pageNo = action.payload;
    },
    setReset: (state, action) => {
      state.search = "";
      state.transectionType = "";
      state.pageNo = 1;
    },
  },
});

export default filterSlice.reducer;
export const { setSearch, setTransectionType, setPageNo, setReset } =
  filterSlice.actions;
